export function getSecurityColor(securityType: string): string {
  switch (securityType?.toUpperCase()) {
    case "EQUITY":
      return "bg-[#241DBA]/[0.05] text-[#241DBA]/[0.7]";
    case "PREFERENCE":
      return "bg-[#2DA900]/[0.05] text-[#2DA900]/[0.7]";
    case "CCD":
      return "bg-[#00A3C7]/[0.05] text-[#00A3C7]";
    case "OCD":
      return "bg-[#E79212]/[0.05] text-[#E79212]";
    case "NOTE":
      return "bg-[#F86161]/[0.05] text-[#F86161]";
    case "WARRANT":
      return "bg-[#6904DC]/[0.2] text-[#6904DC]";
    case "RPS":
      return "bg-[#BAA8ED]/[0.05] text-[#D5CBF4]";
    case "NCD":
      return "bg-[#A6A900]/[0.05] text-[#A6A900]/[0.6]";
    case "OCPS":
      return "bg-[#00AD6F]/[0.05] text-[#00AD6F]/[0.6]";
    case "OCRPS":
      return "bg-[#E79212]/[0.05] text-[#E79212]/[0.6]";
    case "DEBENTURE":
      return "bg-[#FFD467]/[0.05] text-[#FFD467]";
    case "OPTIONS":
      return "bg-[#F86161]/[0.05] text-[#F86161]/[0.6]";
    case "CCPS":
      return "bg-[#2DA900]/[0.05] text-[#2DA900]";
    case "FORFEITED":
      return "bg-[#068077]/[0.05] text-[#068077]";
    default:
      return "bg-[#E8FFF3] text-[#48fa9d]";
  }
}

export function getShareholderTagColor(shareholderType: string): string {
  const type = shareholderType.toUpperCase();
  switch (type) {
    case "FOUNDERS":
      return "text-[#241DBA] border-[#241DBA]";
    case "ANGELS":
      return "text-[#2DA900] border-[#2DA900]";
    case "VC":
      return "text-[#00A3C7] border-[#00A3C7]";
    case "VENTURE CAPITAL":
      return "text-[#00A3C7] border-[#00A3C7]";
    case "INCUBATOR":
      return "text-[#E79212] border-[#E79212]";
    case "ACCELERATOR":
      return "text-[#F86161] border-[#F86161]";
    case "ANGELNETWORK":
      return "text-[6904DC] border-[6904DC]";
    case "ANGEL NETWORK":
      return "text-[6904DC] border-[6904DC]";
    case "OTHERS":
      return "text-[#B5A18A] border-[#B5A18A]";
    case "ANGELFUND":
      return "text-[#9A7CEE] border-[#9A7CEE]";
    case "CORPORATE":
      return "text-[#BABC57] border-[#BABC57]";
    case "FAMILY OFFICE":
      return "text-[#57BF99] border-[#57BF99]";
    case "FAMILYOFFICE":
      return "text-[#57BF99] border-[#57BF99]";
    case "PE":
      return "text-[#E1B774] border-[#E1B774]";
    case "FINANCIAL INSTITUTION":
      return "text-[#2DA900] border-[#2DA900]";
    case "FINANCIALINSTITUTION":
      return "text-[#2DA900] border-[#2DA900]";
    case "OPTIONS":
      return "text-[#E49494] border-[#E49494]";
    case "EMPLOYEE":
      return "text-[#B5A18A]/[0.6] border-[#B5A18A]/[0.6]";
    case "ESOPTRUST":
      return "text-[#ad4d0c] border-[#8c3b04]";
    case "TRUST":
      return "text-[#ad4d0c] border-[#8c3b04]";
    case "FORFEITED":
      return "text-[#084f47] border-[#084f47]";
    case "HNI":
      return "text-[#8B0000] border-[#8B0000]";
    default:
      return "text-[#bf63b5] border-[#bf63b5]";
  }
}

export const shareholderTypeLabelValue = [
  {
    label: "Founder",
    value: "Founder",
  },
  {
    label: "Angels",
    value: "Angels",
  },
  {
    label: "Incubator",
    value: "Incubator",
  },
  {
    label: "Accelerator",
    value: "Accelerator",
  },
  {
    label: "AngelNetwork",
    value: "Angel Network",
  },
  {
    label: "AngelFund",
    value: "Angel Fund",
  },
  {
    label: "VC",
    value: "VC",
  },
  {
    label: "Corporate",
    value: "Corporate",
  },
  {
    label: "FamilyOffice",
    value: "Family Office",
  },
  {
    label: "PE",
    value: "PE",
  },
  {
    label: "FinancialInstitution",
    value: "Financial Institution",
  },
  {
    label: "Options",
    value: "Options",
  },
  {
    label: "Others",
    value: "Others",
  },
  {
    label: "Employee",
    value: "Employee",
  },

  {
    label: "Trust",
    value: "Trust",
  },
  {
    label: "EsopTrust",
    value: "ESOP Trust",
  },
  {
    label: "Forfeited",
    value: "Forfeited",
  },
  {
    label: "HNI",
    value: "HNI",
  },
];
export const getShareholderValue = (value: string) =>
  shareholderTypeLabelValue.find(
    (shareholderType) => shareholderType.label === value,
  )?.value;

export function CaptableTag({
  dataEventName,
  tagName,
}: {
  dataEventName?: string;
  tagName: string;
}) {
  const textColor = getShareholderTagColor(tagName);
  const tagDisplayName = getShareholderValue(tagName);
  return (
    <div
      className={`w-fit h-fit px-1 mb-1 py-0.5 text-xxs rounded-sm font-semibold bg-white border  ${textColor}`}
    >
      <p data-event-name={dataEventName}>{tagDisplayName ?? tagName}</p>
    </div>
  );
}
